<template>
  <div id="app">
    <router-view />
    <!-- <el-backtop :bottom="100" id="backtop"> -->
    <div class="webTop" id="webTop">
      <el-button icon="el-icon-close" circle class="webTopClose" @click="webTopClose"></el-button>
      <ul class="goTop">
        <li @click="goTop">
          <i class="el-icon-arrow-up" style="padding-top: 5px" />
        </li>
        <li>
          <el-tooltip placement="left-start" effect="light">
            <div slot="content" class="tips-content">
              <span>
                <p class="wxText">{{ this.bottom.serviceQrcodeText }}</p>
                <img src="@/assets/wx.jpg" alt="" class="wxImg" />
              </span>
            </div>
            <span><i class="iconfont icon-weixin" /></span>
          </el-tooltip>
        </li>
        <li>
          <el-tooltip placement="left-start" effect="light">
            <div slot="content" class="tips-content">
              <span>
                <p class="wxText">{{ this.bottom.serviceTelText }}</p>
                <p class="phone">{{ this.bottom.serviceTel }}</p>
              </span>
            </div>
            <span><i class="iconfont icon-dianhua1" /></span>
          </el-tooltip>
        </li>
      </ul>
    </div>
    <!-- </el-backtop> -->
  </div>
</template>

<script>
import './assets/icon/iconfont.css'
import { getBase } from '@/api/common.js'
export default {
  name: 'App',
  data() {
    return {
      num: 1,
      bottom: {}
    }
  },
  methods: {
    onscrollShow() {
      let webTop = document.getElementsByClassName('webTop')[0]
      let goTop = document.getElementsByClassName('goTop')[0]
      let _this = this
      window.onscroll = function () {
        if (_this.num === 1) {
          let res = document.body.scrollTop || document.documentElement.scrollTop
          if (res >= 400) {
            webTop.style.display = 'block'
          } else {
            webTop.style.display = 'none'
          }
        }
      }
    },
    goTop() {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
    webTopClose() {
      let webTop = document.getElementsByClassName('webTop')[0]
      this.num = 0
      webTop.style.display = 'none'
      setTimeout(() => {
        this.num = 1
        webTop.style.display = 'block'
      }, 10000)
    },
    async getBase(val) {
      await getBase(val).then((res) => {
        // 缓存到Store
        this.$store.dispatch('saveBase', res.data.base)
        this.$store.dispatch('saveBottom', res.data.bottom)
        this.$store.dispatch('saveLanguages', res.data.languages)
        localStorage.setItem('base', JSON.stringify(res.data.base)) //.base
        localStorage.setItem('bottom', JSON.stringify(res.data.bottom)) //.bottom
        localStorage.setItem('languages', JSON.stringify(res.data.languages)) //.languages
        this.bottom = JSON.parse(localStorage.getItem('bottom'))
      })
    },
  },
  mounted() {
    this.onscrollShow()
  },
  created() {
    this.getBase(0) // 网站基础信息
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333;
  margin-top: 0;
  overflow: hidden;
  box-sizing: border-box;
  width: 100%;
}

body {
  height: 100%;
  background: #fff;
  /* box-sizing: border-box; */
  margin: 0;
  font-family: Microsoft YaHei, 'Avenir', Helvetica, Arial, sans-serif;
  font-size: 14px;
}

img {
  max-width: 100%;
}
video {
  max-width: 100%;
}

a {
  text-decoration: none;
  list-style-type: none;
  color: #333;
}

li {
  text-decoration: none;
  list-style-type: none;
}

body .el-table th.gutter {
  display: table-cell !important;
}

th.gutter,
colgroup.gutter {
  display: table-cell !important;
  width: 17px !important;
}

::-webkit-scrollbar {
}

.webTop {
  z-index: 99999;
  width: 70px;
  position: fixed;
  bottom: 100px;
  right: 20px;
  display: none;
}

.webTop ul {
  padding: 0;
  width: 100%;
  margin: 0;
}

.webTop ul li {
  width: 100%;
  height: 70px;
  border-radius: 4px;
  border: 1px solid #ccc;
  background: #fff;
  margin-bottom: 3px;
  color: #d6162b;
  line-height: 70px;
}

.webTop ul li:hover {
  background: #d6162b;
  color: #fff;
  border: 1px solid #d6162b;
}

.webTop ul li i {
  font-size: 36px;
}

.webTop ul li:first-child {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.webTop ul li:last-child {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.webTopClose {
  position: relative;
  right: -35px;
  top: 25px;
}

.wxText {
  background: #d6162b;
  color: #fff;
  text-align: center;
  line-height: 36px;
  margin: 0;
  font-size: 16px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.wxImg {
  margin: 10px;
}

.phone {
  padding: 0 10px;
  font-size: 16px;
}

@media (max-width: 768px) {
  .webTop {
    width: 50px;
  }

  .webTop ul li {
    height: 50px;
    line-height: 50px;
  }

  .webTopClose {
    position: relative;
    right: -25px;
    top: 15px;
  }

  .el-button.is-circle {
    padding: 6px;
  }
}

.el-tooltip__popper {
  padding: 0;
}

.el-tooltip__popper.is-light {
  border: #ccc;
  border-radius: 6px;
  border: 1px solid #ccc;
  /* top: 85px!important; */
  left: auto;
  margin-right: 30px;
}

.el-tooltip__popper.is-light[x-placement^='left'] .popper__arrow {
  border-left-color: #ccc;
  top: 18px !important;
}

.el-popover {
  min-width: auto;
  text-align: center;
}

.el-popover p {
  line-height: 22px;
}

.qrcode img {
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue